import { createFileRoute } from '@tanstack/react-router';

import { LocationListPage } from '~pages/locations/location-list-page';

export const Route = createFileRoute(
  '/_auth/_layout/category-config/locations',
)({
  component: LocationListPage,
});
